// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".change-log__list_db561169{max-height:14rem}.change-log__clickable_a2e8bf24{cursor:pointer}.change-log__clickable_a2e8bf24:hover{transition:background-color .2s;background-color:#dceffa}.change-log__highlight_f62f9412{background-color:rgba(220,239,250,0.6)}.change-log__text-link_c181dc02{color:inherit;text-decoration:none}.change-log__text-link_c181dc02:hover{color:inherit;text-decoration:none}", ""]);
// Exports
export var changeLogList = "change-log__list_db561169";
export var changeLogClickable = "change-log__clickable_a2e8bf24";
export var changeLogHighlight = "change-log__highlight_f62f9412";
export var changeLogTextLink = "change-log__text-link_c181dc02";
export default ___CSS_LOADER_EXPORT___;
